export const iconFontAwesomeUsersPeopleFaceMeh = (
	<i className="fa-solid fa-face-meh"></i>
);
